import axios from 'axios';

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Projects
export const getProjects = async () => {
  const response = await axios.get(`${API_BASE}/projects`);
  return response.data;
};

export const getProject = async (slug) => {
  const response = await axios.get(`${API_BASE}/projects/${slug}`);
  return response.data;
};

// Admin Projects
export const getAllProjectsAdmin = async () => {
  const response = await axios.get(`${API_BASE}/admin/projects`);
  return response.data;
};

export const createProject = async (project) => {
  const response = await axios.post(`${API_BASE}/admin/projects`, project);
  return response.data;
};

export const updateProject = async (slug, updates) => {
  const response = await axios.put(`${API_BASE}/admin/projects/${slug}`, updates);
  return response.data;
};

export const deleteProject = async (slug) => {
  const response = await axios.delete(`${API_BASE}/admin/projects/${slug}`);
  return response.data;
};

// Trash (Papelera)
export const getDeletedProjects = async () => {
  const response = await axios.get(`${API_BASE}/admin/projects/trash`);
  return response.data;
};

export const restoreProject = async (slug) => {
  const response = await axios.post(`${API_BASE}/admin/projects/${slug}/restore`);
  return response.data;
};

export const permanentDeleteProject = async (slug) => {
  const response = await axios.delete(`${API_BASE}/admin/projects/${slug}/permanent`);
  return response.data;
};

export const reorderProjects = async (order) => {
  const response = await axios.post(`${API_BASE}/admin/projects/reorder`, order);
  return response.data;
};

// Settings
export const getSettings = async () => {
  const response = await axios.get(`${API_BASE}/settings`);
  return response.data;
};

export const updateSettings = async (settings) => {
  const response = await axios.put(`${API_BASE}/admin/settings`, settings);
  return response.data;
};

// Media
export const uploadMedia = async (file, onProgress = null) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_BASE}/admin/media/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 300000, // 5 minutes timeout for large files
    onUploadProgress: onProgress ? (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onProgress(percentCompleted);
    } : undefined,
  });
  return response.data;
};

export const listMedia = async () => {
  const response = await axios.get(`${API_BASE}/admin/media`);
  return response.data;
};

export const deleteMedia = async (filename) => {
  const response = await axios.delete(`${API_BASE}/admin/media/${filename}`);
  return response.data;
};

// Cloudinary Library
export const getCloudinaryLibrary = async (resourceType = 'image') => {
  const response = await axios.get(`${API_BASE}/admin/cloudinary/library`, {
    params: { resource_type: resourceType }
  });
  return response.data;
};
